export default "__VITE_ASSET__b08b6657__"